(() => {
  const delay = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));
  const metadataFor = (item) => {
    const raw = item?.properties?.__kaching_bundles;
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      return null;
    }
  };

  const recover = ({ groupId, matches }) => {
    let cancelled = false;
    const promise = (async () => {
      let ambiguous = false;
      for (const waitMs of [500, 700, 900, 1200, 1600, 2100, 2700, 3400, 4000]) {
        await delay(waitMs);
        if (cancelled) return { matched: false, ambiguous: false, result: null };
        try {
          const response = await window.fetch('/cart.js', {
            headers: { Accept: 'application/json' },
            cache: 'no-store'
          });
          if (!response.ok) continue;
          const cart = await response.json();
          const items = Array.isArray(cart?.items) ? cart.items : [];
          const mainItem = items.find((item) => {
            const properties = item?.properties || {};
            return String(properties._safewalk_package_group || '') === String(groupId)
              && properties._safewalk_package_role === 'main';
          });
          if (!mainItem) continue;
          const privateGroupId = String(metadataFor(mainItem)?.id || '');
          const linkedItems = privateGroupId
            ? items.filter((item) => item === mainItem || String(metadataFor(item)?.id || '') === privateGroupId)
            : [mainItem];
          const result = { ok: true, status: response.status, body: { items: linkedItems }, recovered: true };
          if (matches(result)) return { matched: true, ambiguous: false, result };
          ambiguous = true;
        } catch (error) {
          continue;
        }
      }
      return { matched: false, ambiguous, result: null };
    })();
    return {
      promise,
      cancel: () => { cancelled = true; }
    };
  };

  window.SafeWalkV51KachingRecovery = Object.freeze({ recover });
})();
